/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Spec_PlatformsInputs */

const en_home_spec_platforms = /** @type {(inputs: Home_Spec_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms`)
};

/**
* | output |
* | --- |
* | "Platforms" |
*
* @param {Home_Spec_PlatformsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_spec_platforms = /** @type {((inputs?: Home_Spec_PlatformsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Spec_PlatformsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_spec_platforms(inputs)
});
export { home_spec_platforms as "home.spec.platforms" }